import { DatePicker, Input, message, TimePicker } from "antd";
import dayjs from "dayjs";

const CreateContractDate = ({ contract, setContract, finiteTerm = true }) => {
  const selectStartDate = (date) => {
    if (
      date &&
      contract.endDate &&
      date > new Date(contract.endDate)
    ) {
      message.error("La date de début doit être antérieure à la date de fin.");
    } else {
      setContract({ ...contract, startDate: date });
    }
  };

  const selectEndDate = (date) => {
    if (
      date &&
      contract.startDate &&
      date < new Date(contract.startDate)
    ) {
      message.error(
        "La date de fin doit être postérieure à la date de début.",
      );
    } else {
      setContract({ ...contract, endDate: date });
    }
  };

  
  return (
    <div>
      <p className="text-sm font-semibold text-left text-slate-900">Date de la mission</p>

      <div className="flex items-center my-3 space-x-2 justify-center">
        <DatePicker
          //onChange={(e) => setContract({...contract,startDate:e.$d})}
          onChange={(e) => selectStartDate(e?.toDate() || null)}
          value={contract.startDate ? dayjs(contract?.startDate) : null}
          className="w-1/2 h-10"
          format="DD/MM/YYYY"
          placeholder="Date de début de la mission"
        />
        {finiteTerm && (        <DatePicker
          //onChange={(e) => setContract({...contract,endDate:e.$d})}
          onChange={(e) => selectEndDate(e?.toDate() || null)}
          value={contract.endDate ? dayjs(contract?.endDate) : null}
          className="w-1/2 h-10"
          format="DD/MM/YYYY"
          placeholder="Date de fin de la mission"
        />)}
      </div>

      <div className="flex items-center my-3 space-x-2">
        <TimePicker
          value={contract.startHour ? dayjs(contract.startHour) : null}
          onChange={(newValue) =>
            setContract({
              ...contract,
              startHour: newValue?.toDate() || null,
            })
          }
          format="HH:mm"
          className="w-1/2 outline-none"
          placeholder="Heure de début"
        />
        <TimePicker
          format="HH:mm"
          value={contract.endHour ? dayjs(contract.endHour) : null}
          className="w-1/2 outline-none focus:outline-none hover:outline-none"
          onChange={(newValue) =>
            setContract({
              ...contract,
              endHour: newValue?.toDate() || null,
            })
          }
          placeholder="Heure de fin"
        />
      </div>
      <div>
        <Input
          onChange={(e) =>
            setContract({ ...contract, nbHeureHebdo: e.target.value })
          }
          value={contract.nbHeureHebdo ? `${contract.nbHeureHebdo}` : null}
          className="rounded-md bcontract bcontract-gray-300 mb-2 mt-3"
          placeholder="Nombre heures hebdomadaire"
        />
      </div>
    </div>
  );
};

export default CreateContractDate;
